import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const EncounterService = {
    list: async (headers) => axios.get(API_KEEPER + "/encounter/list", {headers}).then(({ data }) => data).catch((err) => { throw err }),

    userIdentification: async () => axios.get(API_URL + "/user/get/userIdentification").then(({ data }) => data).catch((err) => { throw err }),

    getEncounter: async (id) => axios.get(API_URL + `/encounter/getEncounter/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    getCorporationsHeader: async () => axios.get(API_URL + "/corporation/getTemplates").then(({ data }) => data).catch((err) => { throw err }),

    getIndividualCpf: async (cpf) => axios.get(API_URL + `/individual/${cpf}`).then(({ data }) => data).catch((err) => { throw err }),

    update: async (formData) => axios.post(API_KEEPER + "/encounter/update", formData).then(({ data }) => data).catch((err) => { throw err }),

    encountersByCpf: async (cpf) => axios.get(API_URL + `/api/encounters/individuals/${cpf}`).then(({ data }) => data).catch((err) => { throw err }),

    getEncounterActions: async () => axios.get(API_URL + `/api/encounters/actions`).then(({ data }) => data).catch((err) => { throw err }),
};

export default EncounterService;
